var map = {
	"./discord.svg": 458,
	"./evernote.svg": 9392,
	"./facebook.svg": 5925,
	"./gmail.svg": 8588,
	"./google_docs.svg": 4799,
	"./google_sheets.svg": 9907,
	"./linkedin.svg": 6167,
	"./microsoft_word.svg": 7002,
	"./outlook.svg": 7057,
	"./reddit.svg": 7702,
	"./salesforce.svg": 673,
	"./slack.svg": 6041,
	"./twitter.svg": 8505,
	"./whatsapp.svg": 3938,
	"./youtube.svg": 7698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8278;